import { baseUrl } from "../../utils/constants";
import { client } from "../client";
import {
  GETASSEMBLYCONSTITUENCYLIST,
  ASSEMBLYCONSTITUENCY,
  GETASSEMBLYCONSTITUENCYGRID,
  GETASSEMBLYCONSTITUENCBYZONEID,
} from "../endpoints";

export const createAssemblyConstituency = async ({
  assemblyConstituencyName,
  zoneId,
}: {
  assemblyConstituencyName: string;
  zoneId: number;
}) => {
  const response = await client.post(`${baseUrl}${ASSEMBLYCONSTITUENCY}`, {
    assemblyConstituencyName,
    zoneId,
  });
  return response;
};

export const updateAssemblyConstituency = async ({
  assemblyConstituencyName,
  assemblyConstituencyId,
  zoneId,
}: {
  assemblyConstituencyId: number;
  assemblyConstituencyName: string;
  zoneId: number;
}) => {
  const response = await client.put(`${baseUrl}${ASSEMBLYCONSTITUENCY}`, {
    assemblyConstituencyId: assemblyConstituencyId,
    assemblyConstituencyName: assemblyConstituencyName,
    zoneId: zoneId,
  });
  return response;
};

export const getAllAssemblyConstituency = async () => {
  const response = await client.get(`${baseUrl}${GETASSEMBLYCONSTITUENCYLIST}`);
  return response;
};

export const getAssemblyConstituencyById = async (
  assemblyConstituencyId: number
) => {
  const response = await client.get(
    `${baseUrl}${ASSEMBLYCONSTITUENCY}?assemblyConstituencyId=${assemblyConstituencyId}`
  );
  return response;
};

export const getAssemblyConstituencyGrid = async ({
  page,
  size,
  searchQuery,
}: {
  page: number;
  size: number;
  searchQuery: string;
}) => {
  const response = await client.get(
    `${baseUrl}${GETASSEMBLYCONSTITUENCYGRID}`,
    {
      params: {
        page,
        size,
        searchQuery,
      },
    }
  );
  return response;
};

export const removeAssemblyConstituencyFromUser = async (
  assemblyConstituencyId: number
) => {
  const response = await client.delete(`${baseUrl}${ASSEMBLYCONSTITUENCY}`, {
    data: {
      assemblyConstituencyId: assemblyConstituencyId,
    },
  });
  return response;
};

export const getAssemblyConstituencyByZoneId = async (zoneId: number) => {
  const response = await client.get(
    `${baseUrl}${GETASSEMBLYCONSTITUENCBYZONEID}?zoneId=${zoneId}`
  );
  return response;
};
